import { Component } from '@angular/core';
import { IzzySLAPolicyEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'SLA Policies') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyslapolicy-form',
    templateUrl: './izzyslapolicy.form.component.html'
})
export class IzzySLAPolicyFormComponent extends BaseFormComponent {
    public record!: IzzySLAPolicyEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'policyDetails', sectionName: 'Policy Details', isExpanded: true },
            { sectionKey: 'sLATargets', sectionName: 'SLA Targets', isExpanded: true },
            { sectionKey: 'escalationPath', sectionName: 'Escalation Path', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false },
            { sectionKey: 'ticketSLAStates', sectionName: 'Ticket SLA States', isExpanded: false }
        ]);
    }
}

